export default __webpack_public_path__ + "static/media/1.d79b8887.jpg";